/**
 * Kitchen API utilities
 * Photo analysis and meal suggestion endpoints
 */

import { API_URL } from '../constants';

/**
 * Analyze a photo to extract food items
 * @param {string} token - Auth token
 * @param {string} imageBase64 - Base64 encoded image (with or without data: prefix)
 * @returns {Promise<{success: boolean, items?: Array, error?: string}>}
 */
export async function analyzePhoto(token, imageBase64) {
  try {
    const response = await fetch(`${API_URL}/api/kitchen/analyze-photo`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify({ image: imageBase64 })
    });

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Photo analysis error:', error);
    return {
      success: false,
      error: error.message || 'Failed to analyze photo'
    };
  }
}

/**
 * Get meal suggestions based on inventory
 * @param {string} token - Auth token
 * @param {Array} inventory - Array of inventory items
 * @param {number} count - Number of meal suggestions to generate
 * @param {Object} preferences - Optional user preferences
 * @returns {Promise<{success: boolean, meals?: Array, error?: string}>}
 */
export async function suggestMeals(token, inventory, count = 6, preferences = null) {
  try {
    const response = await fetch(`${API_URL}/api/kitchen/suggest-meals`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify({ inventory, count, preferences })
    });

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Meal suggestion error:', error);
    return {
      success: false,
      error: error.message || 'Failed to generate meal suggestions'
    };
  }
}
